export default __webpack_public_path__ + "static/media/custom.e8d0ea2f.svg";